<div class="user-list">
    <cv-add-user [(show)]="isAddingUser" (onSave)="addedNewUser()" [listProfileDTOs]="listProfileDTOs" [baseGroupTypes]="baseGroupTypes"
                 [groupNames]="groupNames" [ldGroups]="allLDGroups" [languages]="langs"></cv-add-user>
    <!--User List top row-->
    <div class="row mt-4">
        <div class="col-9 mb-3">
            <button id="addUserPlus" title="Add User" type="button" *ngIf="permissions?.CreateAccess" class="btn btn-primary btn-icon" (click)="addNewUser()">
                <svg><use href="../App_Themes/clearview-default/icons/utility/add.svg#add"></use></svg>
                <span cvLocalizedText langSection="Users" langKey="New_User">New User</span>
            </button>
        </div>
        <div class="col-3 mb-3 d-flex align-items-end">
            <div class="search-box live-search">
                <input type="search" class="form-control form-control-gray" name="CustomFilter" [(ngModel)]="searchFilter" (ngModelChange)="externalFilterChanged()"
                       cvLocalizedPlaceholder langSection="Users" langKey="Search" placeholder="Search" autocomplete="off" />
                <span class="clear-input" *ngIf="searchFilter.length > 0" (click)="clearFilter()"></span>
            </div>
        </div>
    </div>
    <!--User List second row-->
    <div class="row">
        <div class="col-sm-8 d-flex">
            <div class="btn-group text-dropdown" ngbDropdown>
                <button id="textDropdown" type="button" class="btn btn-text" ngbDropdownToggle cvLocalizedText langSection="Users" langKey="Filter">
                    Filter <span class="caret"></span>
                </button>
                <div class="dropdown-menu p-3" ngbDropdownMenu aria-labelledby="textDropdown">
                    <div class="form-check" ngbDropdownItem>
                        <input class="form-check-input" type="radio" id="filter_emp" value="0" [(ngModel)]="relatedGroupTypeFilter"
                               (click)="externalFilterChanged()" />
                        <label class="form-check-label" for="filter_emp" cvLocalizedText langSection="Users" langKey="Employee">
                            Employee
                        </label>
                    </div>
                    <div class="form-check" ngbDropdownItem>
                        <input class="form-check-input" type="radio" id="filter_rec" value="1" [(ngModel)]="relatedGroupTypeFilter"
                               (click)="externalFilterChanged()" />
                        <label class="form-check-label" for="filter_rec" cvLocalizedText langSection="Users" langKey="Campaign">
                            Campaign
                        </label>
                    </div>
                    <div class="dropdown-divider"></div>
                    <div class="form-check" ngbDropdownItem>
                        <input class="form-check-input" type="checkbox" id="filter_act" [(ngModel)]="activeButtons.active"
                               (click)="externalFilterChanged()" />
                        <label class="form-check-label" for="filter_act" cvLocalizedText langSection="Users" langKey="Active">
                            Active
                        </label>
                    </div>
                    <div class="form-check" ngbDropdownItem>
                        <input class="form-check-input" type="checkbox" id="filter_ina" [(ngModel)]="activeButtons.inactive"
                               (click)="externalFilterChanged()" />
                        <label class="form-check-label" for="filter_ina" cvLocalizedText langSection="Users" langKey="Inactive">
                            Inactive
                        </label>
                    </div>
                    <div class="dropdown-divider"></div>
                    <div class="form-check" ngbDropdownItem>
                        <input class="form-check-input" type="checkbox" id="filter_app" [(ngModel)]="activeButtons.needsApproval"
                               (click)="externalFilterChanged()" />
                        <label class="form-check-label" for="filter_app" cvLocalizedText langSection="Users" langKey="Needs_Approval">
                            Needs Approval
                        </label>
                    </div>
                    <div class="form-check" ngbDropdownItem>
                        <input class="form-check-input" type="checkbox" id="filter_lock" [(ngModel)]="activeButtons.lockedOutUser"
                               (click)="externalFilterChanged()" />
                        <label class="form-check-label" for="filter_lock" cvLocalizedText langSection="Users" langKey="Locked_Out">
                            Locked Out 
                        </label>
                    </div>
                </div>
                <div>
                </div>
            </div>
        </div>
        <div class="col-sm-4 dropdown d-flex justify-content-end">
            <cv-generic-export [items]="items" [fileName]="getLocalizationString('Users', 'Users')"></cv-generic-export>
        </div>
    </div>

    <!--User List-->
    <div class="row">
        <div class="col-12">
            <div class="userList">
                <ag-grid-angular #userListGrid *ngIf="gridOptions != null" class="ag-theme-balham ag-basic" [gridOptions]="gridOptions"></ag-grid-angular>
            </div>
        </div>
    </div>
</div>
